
/**
 * @class
 */
function __monkberry_sideNav() {
  Monkberry.call(this);
  var _this = this;

  // Create elements
  var h30 = document.createElement('h3');
  var ul1 = document.createElement('ul');
  var children0 = new Monkberry.Map();

  // Construct dom
  h30.appendChild(document.createTextNode("Todo List"));

  // Update functions
  this.__update__ = {
    todos: function (todos) {
      Monkberry.loop(_this, ul1, children0, __monkberry_sideNav_for0, todos, {"value":"todo"});
    }
  };

  // On update actions
  this.onUpdate = function (__data__) {
    children0.forEach(function (view) {
      view.update(view.__state__);
      view.update(__data__);
      view.update(view.__state__);
    });
  };

  // Set root nodes
  this.nodes = [h30, ul1];
}
__monkberry_sideNav.prototype = Object.create(Monkberry.prototype);
__monkberry_sideNav.prototype.constructor = __monkberry_sideNav;
__monkberry_sideNav.pool = [];
__monkberry_sideNav.prototype.update = function (__data__) {
  if (__data__.todos !== undefined) {
    this.__update__.todos(__data__.todos);
  }
  this.onUpdate(__data__);
};

/**
 * @class
 */
function __monkberry_sideNav_for0() {
  Monkberry.call(this);
  this.__state__ = {};

  // Create elements
  var li0 = document.createElement('li');
  var text1 = document.createTextNode('');

  // Construct dom
  li0.appendChild(document.createTextNode("todo : "));
  li0.appendChild(text1);

  // Update functions
  this.__update__ = {
    todo: function (todo) {
      text1.textContent = todo.text;
    }
  };

  // Set root nodes
  this.nodes = [li0];
}
__monkberry_sideNav_for0.prototype = Object.create(Monkberry.prototype);
__monkberry_sideNav_for0.prototype.constructor = __monkberry_sideNav_for0;
__monkberry_sideNav_for0.pool = [];
__monkberry_sideNav_for0.prototype.update = function (__data__) {
  if (__data__.todo !== undefined && __data__.__index__ !== undefined) {
    this.__update__.todo(__data__.todo);
  }
};

window.__monkberry_sideNav = __monkberry_sideNav;
